import { getIsPromoCodeValid } from './payments/promo-validity-handler';

export const APPLY_BUTTON_KEY = 'isApplyButtonClicked';

export const promoCode = {
  dom: {},
  elements: {
    url: null,
    isApplyButtonClicked: null,
  },
  init() {
    this.hasErrorsClient = false;
    this.dom.applyPromoCodeButton = document.querySelector('.apply-promo-code');
    this.dom.promoCodeInputField = document.querySelector('.js-promo-input');
    this.dom.promoCodeButtons = document.querySelectorAll('.js-promo-clickable');
    this.dom.promoCodeModal = document.querySelector('.js-promo-code-modal');
    this.dom.modalCloseButton = document.querySelector('.js-close-modal-clickable');
    this.dom.promoCodeForm = document.querySelector('#promo-code-form');
    this.dom.errorMessageContainer = this.dom.promoCodeModal.querySelector('.error-message');

    this.isCodeValidServer = getIsPromoCodeValid();

    if (localStorage.getItem(APPLY_BUTTON_KEY) && document.querySelector('#error-message')) {
      localStorage.removeItem(APPLY_BUTTON_KEY);
    }

    // show modal when invalid promo code is entered and we have not initiated payment
    if (
      this.dom.promoCodeInputField.value &&
      !this.isCodeValidServer &&
      ['#select-payment-method', '#subscription'].indexOf(window.location.hash) > -1
    ) {
      this.openModal();
    }

    this.dom.promoCodeForm.addEventListener('submit', this.onSubmit.bind(this));
    this.dom.modalCloseButton.addEventListener('click', this.closeModal.bind(this));
    this.dom.promoCodeButtons.forEach(button => {
      button.addEventListener('click', this.openModal.bind(this));
    });

    this.dom.promoCodeInputField.addEventListener('keyup', event => {
      this.validatePromoCode(this.dom.promoCodeInputField);
      this.setApplyButtonState(this.dom.promoCodeInputField);
    });

    this.constructLinkWithParams(this.dom.promoCodeInputField);
    this.setApplyButtonState(this.dom.promoCodeInputField);
  },
  onSubmit(e) {
    e.preventDefault();

    if (this.hasErrorsClient) {
      return;
    }

    localStorage.setItem(APPLY_BUTTON_KEY, true);

    this.dom.promoCodeInputField.disabled = true;
    this.dom.applyPromoCodeButton.disabled = true;
    this.constructLinkWithParams(this.dom.promoCodeInputField);

    if (window.location.href === window.getHost() + this.elements.url) {
      window.location.reload();
    } else {
      window.location.href = this.elements.url;
    }
  },
  closeModal() {
    if (this.dom.promoCodeModal.classList.contains('flex')) {
      this.dom.promoCodeModal.classList.add('hidden');
      this.dom.promoCodeModal.classList.remove('flex');
      document.body.classList.remove('overflow-hidden');
      this.removePromoCodeFromQuery();
    }
  },
  openModal() {
    this.dom.promoCodeModal.classList.add('flex');
    this.dom.promoCodeModal.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  },
  removePromoCodeFromQuery() {
    const query = new URLSearchParams(window.location.search);
    query.delete('promoCode');
    window.history.replaceState(null, null, window.location.pathname + '?' + query.toString() + window.location.hash);
  },
  validatePromoCode(field) {
    const specialChars = /[^a-zA-Z0-9]/g;
    this.hasErrorsClient = specialChars.test(field.value);
    this.dom.errorMessageContainer.classList.toggle('hidden', !this.hasErrorsClient);
  },
  setApplyButtonState(inputField) {
    this.dom.applyPromoCodeButton.disabled = inputField.value.length === 0 || this.hasErrorsClient;
  },
  constructLinkWithParams(field) {
    const data = {
      checkout: '/checkout?customerUuid=',
      customerUuid: window.getCustomerUuid(),
      uuid: '&uuid=',
      currentPurchaseUuid: window.getUuid(),
      promoParam: '&promoCode=',
      promoCode: field.value,
      path: '#select-payment-method',
    };

    this.elements.url = this.encodeQueryData(data);
  },
  encodeQueryData(data) {
    const params = [];
    for (let element in data) {
      params.push(data[element]);
    }

    return params.join('');
  },
};

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.js-promo-code-modal')) {
    promoCode.init();
  }
});
